export default __webpack_public_path__ + "static/xpress-fuel-b477677f1a046eea16f4407ef822e3ae.png";